import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import { tryFormatDate } from '@netwealth/nw-utils';
import { PillComponent } from '../../../pill/pill.component';
import { IconComponent } from '../../../icon/icon.component';
import { TintDirective } from '../tint/tint.directive';
import { UmbracoBlockConfiguration } from '../../models/umbraco-blocks.types';
import { NgOptimizedImage } from '@angular/common';

const PARSE_FORMAT: string = 'dd/MM/yyyy HH:mm:ss';
const DISPLAY_FORMAT: string = 'dd MMMM yyyy';

@Component({
    selector: 'nw-article-card',
    imports: [PillComponent, IconComponent, TintDirective, NgOptimizedImage],
    templateUrl: './article-card.component.html',
    styleUrl: './article-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class ArticleCardComponent implements OnChanges {
    @Input() image?: string;
    @Input() imageTint?: UmbracoBlockConfiguration.Tint;
    @Input() category?: string;
    @Input() author?: string;
    @Input() avatar?: string;
    @Input() date?: string;
    @Input() tabindex: number = -1;
    @Input() path?: string;
    @Input() categorycolor?: string = undefined;
    @Input() type: 'Article' | 'Webinar' | 'Infogram' = 'Article';
    @Input({ transform: booleanAttribute }) horizontal: boolean = false;

    public publishedDate?: string;
    public id: string = this.generateUniqueId();

    private tint?: UmbracoBlockConfiguration.Tint;

    public ngOnChanges({ date, imageTint }: SimpleChanges): void {
        if (date) {
            this.publishedDate = tryFormatDate(this.date, DISPLAY_FORMAT, PARSE_FORMAT);
        }
        if (imageTint?.currentValue) {
            this.tint = `${this.imageTint}` as UmbracoBlockConfiguration.Tint;
        }
    }

    private generateUniqueId(length = 10) {
        const CHARS: string = 'abcdefghijklmnopqrstuvwxyz';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += CHARS.charAt(Math.floor(Math.random() * CHARS.length));
        }
        return result;
    }

    public mouseEnter(): void {
        this.imageTint = 'none';
    }
    public mouseLeave(): void {
        this.imageTint = this.tint;
    }
}
